import auroraColorPalette from '../colors';

const appbar = {
  root: {
    boxShadow: 'none',
  },
  colorPrimary: {
    backgroundColor: auroraColorPalette.primary.main,
  },
};

export default appbar;
